import { Stack, StackProps, SxProps, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import React, { forwardRef, ReactNode } from 'react';

export type DragAndDropBlockProps = {
  children?: ReactNode;
  sx?: SxProps<Theme>;
} & Omit<StackProps, 'sx'>;

export const DragAndDropBlock = forwardRef<HTMLDivElement, DragAndDropBlockProps>(
  ({ children, sx, ...stackProps }, ref) => {
    return (
      <Stack
        ref={ref}
        overflow="hidden"
        justifyContent="center"
        alignItems="center"
        direction="row"
        gap={1}
        p={5.25}
        {...stackProps}
        sx={(theme) => ({
          borderRadius: theme.spacing(1),
          bgcolor: theme.palette.background.paper,
          border: `5px dashed ${theme.palette.common.grey3}`,
          outline: `5px solid ${theme.palette.background.paper}`,
          outlineOffset: '-6px',
          [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
          },
          ...((typeof sx === 'function' ? sx(theme) : sx) as SystemStyleObject),
        })}
      >
        {children}
      </Stack>
    );
  },
);
